import { mergeChannelParams } from '.';

export function dealwithChannelToSave(params: any) {
  const { channel_type, channel, ...otherParams } = params;

  if (channel_type) {
    const channelObj = mergeChannelParams(params);
    return {
      channel_comments: ['-99999'],
      channel_news: ['-99999'],
      channel_securitys: ['-99999'],
      channel_social: ['-99999'],
      ...otherParams,
      ...channelObj,
    };
  }

  return params;
}
